import { render, staticRenderFns } from "./tsxiansuo.vue?vue&type=template&id=900e5400&scoped=true&"
import script from "./tsxiansuo.vue?vue&type=script&lang=js&"
export * from "./tsxiansuo.vue?vue&type=script&lang=js&"
import style0 from "./tsxiansuo.vue?vue&type=style&index=0&id=900e5400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900e5400",
  null
  
)

export default component.exports